import { useMemo } from "react";
import useTimePeriode from "@/hooks/useTimePeriode";
import { formatDateIndonesia } from "@/lib/utils";
import Card from "../Card";
import { Timeline, TimelineItem } from "../Timeline";

export default function TimelineDaftarkembali() {
  const { dataPeriode } = useTimePeriode();

  // Logika untuk menentukan fase mana yang sedang aktif
  const activePhase = useMemo(() => {
    const now = new Date().getTime();

    // Helper untuk konversi string tanggal ke milidetik secara aman
    const getTime = (dateString?: string | null): number | null =>
      dateString ? new Date(dateString).getTime() : null;

    const tMulaiIsiUkt = getTime(dataPeriode?.waktu_mulai_isi_ukt);
    const tPengumuman = getTime(dataPeriode?.waktu_pengumuman);
    const tMulaiDaftarKembali = getTime(dataPeriode?.waktu_mulai_daftarkembali);

    return {
      // Aktif jika sudah mulai isi UKT, tapi belum waktu pengumuman
      isWaktuIsiUkt: !!(
        tMulaiIsiUkt &&
        now >= tMulaiIsiUkt &&
        (!tPengumuman || now < tPengumuman)
      ),
      // Aktif jika sudah waktu pengumuman, tapi belum mulai daftar kembali/pembayaran
      isPengumuman: !!(
        tPengumuman &&
        now >= tPengumuman &&
        (!tMulaiDaftarKembali || now < tMulaiDaftarKembali)
      ),
      // Aktif jika sudah masuk waktu daftar kembali/pembayaran
      isPembayaran: !!(tMulaiDaftarKembali && now >= tMulaiDaftarKembali),
    };
  }, [dataPeriode]);

  return (
    <div className="mb-3 lg:w-[20rem] lg:sticky lg:top-6 backdrop-blur-md">
      <Card>
        <Timeline containerClass={"border-primary"}>
          <TimelineItem
            title="Waktu isi UKT"
            value={`${formatDateIndonesia(dataPeriode?.waktu_mulai_isi_ukt || "", "medium")} - ${formatDateIndonesia(dataPeriode?.waktu_selesai_isi_ukt || "", "medium")}`}
            isActive={activePhase.isWaktuIsiUkt}
            activeColorClass={"bg-primary"}
            badgeText="Wajib Tepat Waktu"
          />

          <TimelineItem
            title="Pengumuman UKT"
            value={`${formatDateIndonesia(dataPeriode?.waktu_pengumuman || "", "medium")}`}
            isActive={activePhase.isPengumuman}
            activeColorClass={"bg-primary"}
          />

          <TimelineItem
            title="Pembayaran UKT / Cetak NIM"
            value={`${formatDateIndonesia(dataPeriode?.waktu_mulai_daftarkembali || "", "medium")} - ${formatDateIndonesia(dataPeriode?.waktu_selesai_daftarkembali || "", "medium")}`}
            isActive={activePhase.isPembayaran}
            activeColorClass={"bg-primary"}
          />
        </Timeline>
      </Card>
    </div>
  );
}
